import TimeIcon from './TimeIcon'

export default TimeIcon